import {
  FaShieldAlt,
  FaCloudUploadAlt,
  FaTools,
  FaUserTie,
  FaEye,
  FaClock,
  FaLaptopCode,
  FaMobileAlt,
  FaPlug,
  FaWrench,
} from "react-icons/fa";
import "../../Components/style/CloudQuality.css"; // Custom CSS file for styling

import img1 from "../../image/Image _ Page/Service_popup/Software Solutions-main.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/Software Solutions-2.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/Software Solutions-3.jpeg";
import ServiceSlider from "../../Components/serviceslide";

// Blue/white icon-card data for the "solution-card" section.
// Kept separate from JSX so it's easy to add/remove a card later.
const SOLUTION_CARDS = [
  {
    icon: <FaLaptopCode size={20} />,
    title: "Custom Software Development",
    desc: "Develop tailored software solutions to streamline operations and drive business growth.",
  },
  {
    icon: <FaMobileAlt size={20} />,
    title: "Mobile App Development",
    desc: "Build robust, scalable, and user-friendly mobile applications for iOS and Android.",
  },
  {
    icon: <FaPlug size={20} />,
    title: "Software Integration",
    desc: "Seamlessly integrate different software systems to improve data flow and enhance performance.",
  },
  {
    icon: <FaWrench size={20} />,
    title: "Software Maintenance",
    desc: "Ensure long-term reliability and performance of your software through continuous updates and maintenance.",
  },
  {
    icon: <FaShieldAlt size={20} />,
    title: "Data Security",
    desc: "Protect your software and data with advanced security protocols and continuous monitoring.",
  },
];

// Blue/white rectangle-card data for the "quality" section list.
const QUALITY_ITEMS = [
  {
    icon: <FaUserTie size={36} color="#2563EB" />,
    title: "Experienced Software Professionals",
    desc: "Our team of certified experts brings years of software development and deployment experience for your success.",
  },
  {
    icon: <FaTools size={36} color="#2563EB" />,
    title: "Best Practices & Tools",
    desc: "Leverage proven methodologies, tools, and frameworks to ensure seamless software operations.",
  },
  {
    icon: <FaShieldAlt size={36} color="#2563EB" />,
    title: "Advanced Security",
    desc: "Implement rigorous security measures, encryption, and compliance for data protection.",
  },
  {
    icon: <FaEye size={36} color="#2563EB" />,
    title: "Continuous Monitoring",
    desc: "Proactive monitoring to resolve issues quickly and keep your software running smoothly.",
  },
  {
    icon: <FaClock size={36} color="#2563EB" />,
    title: "24/7 Support",
    desc: "Get round-the-clock support from our team to address any software-related queries or challenges.",
  },
  {
    icon: <FaCloudUploadAlt size={36} color="#2563EB" />,
    title: "Scalable Software Solutions",
    desc: "Scale your software infrastructure effortlessly to meet growing business demands.",
  },
];

const Software = () => {
  return (
    <div>
      {/**this is banner section  */}
          <div style={{ position: "relative", width: "100%", height: "60vh" }}>
                 {/* Image */}
                 <img
                   src={img1}
                   alt="Inner Banner"
                   style={{
                     width: "100%",
                     height: "100%",
                     objectFit: "cover",
                    
                   }}
                 />
         
                 {/* Centered Text */}
                 <h2
                   style={{
                     position: "absolute",
                     top: "50%",
                     left: "50%",
                     transform: "translate(-50%, -50%)",
                     color: "white",
                     fontSize: "3rem",
                     fontWeight: "bold",
                     textShadow: "2px 2px 8px rgba(0, 0, 0, 0.7)",
                   }}
                 >
                   Software  solution 
                 </h2>
               </div>

      <section className="about-services-section">
        <div className="container">
          <div className="content-wrapper">
            {/* Image Box */}
            <div className="image-box">
              <img
                src={img2}
                alt="Software Service"
                className="service-image"
              />
              <div className="image-overlay">
                <span className="overlay-text">Discover Software Services</span>
              </div>
            </div>

            {/* Text Box */}
            <div className="text-box">
              <h5 className="section-subtitle">Software Solutions</h5>
              <h2 className="section-title">
                Elevate Your Business with{" "}
                <span className="highlight-text">Software Services</span>
              </h2>
              <p className="section-description">
                Unlock the potential of custom software development to transform
                your business operations. Our software solutions offer
                integration, flexibility, and enhanced productivity tailored to
                your unique needs.
              </p>
              <p className="section-description">
                From software development to maintenance, we ensure your systems
                run smoothly, securely, and efficiently. Whether you're looking
                for enterprise software or custom apps, we've got you covered.
                Trust our experienced team to help you stay ahead in the digital
                world.
              </p>
              {/* <button className="cta-button">Learn More</button> */}
            </div>
          </div>
        </div>
      </section>

      {/* ============ SOLUTION CARDS (blue/white icon-card grid, 3 per row) ============ */}
      <section style={{ padding: "60px 40px", background: "#F3F6FC" }}>
        <style>{`
          @media (max-width: 900px) {
            .orryx-solution-grid { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 560px) {
            .orryx-solution-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            className="orryx-solution-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "20px",
            }}
          >
            {SOLUTION_CARDS.map((card) => (
              <div
                key={card.title}
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  padding: "26px",
                  boxShadow: "0 4px 16px rgba(15,23,42,0.05)",
                }}
              >
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "10px",
                    background: "#DCE6FB",
                    color: "#2563EB",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px",
                  }}
                >
                  {card.icon}
                </div>
                <h5 style={{ fontSize: "16px", fontWeight: 700, margin: 0, marginBottom: "8px", color: "#111827" }}>
                  {card.title}
                </h5>
                <p style={{ fontSize: "13.5px", color: "#6B7280", lineHeight: 1.6, margin: 0, marginBottom: "14px" }}>
                  {card.desc}
                </p>
                <span style={{ color: "#2563EB", fontWeight: 600, fontSize: "13px" }}>
                  Read More →
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ============ QUALITY SECTION (blue/white rectangle boxes, centered) ============ */}
      <section className="quality" style={{ width: "100%" }}>
        <div
          className="container"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <div
            className="quality-content"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              width: "100%",
              maxWidth: "100%",
              flex: "none",
            }}
          >
            <div className="para">
              <p>Ensuring Exceptional Quality for Software Services</p>
            </div>
            <div className="quality-head">
              <h2>
                Our Commitment to Delivering Reliable and Scalable Software
                Solutions
              </h2>
            </div>

            {/* List of Features */}
            <ul className="list-item" style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", alignItems: "center", gap: "16px", width: "100%" }}>
              {QUALITY_ITEMS.map((item) => (
                <li key={item.title} style={{ width: "100%", maxWidth: "620px" }}>
                  <div
                    className="list-box"
                    style={{
                      background: "#fff",
                      borderRadius: "14px",
                      boxShadow: "0 4px 16px rgba(15,23,42,0.06)",
                      padding: "22px 26px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "12px",
                    }}
                  >
                    <div className="list-icon">
                      {item.icon}
                    </div>
                    <div>
                      <h4 className="list-head" style={{ margin: 0, marginBottom: "6px", fontSize: "17px", fontWeight: 700, color: "#111827" }}>
                        {item.title}
                      </h4>
                      <p style={{ margin: 0, color: "#6B7280", fontSize: "14px", lineHeight: 1.6 }}>
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <div className="service-slider-wrapper">
        <ServiceSlider />
      </div>
    </div>
  );
};

export default Software;